import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts } from "@saleor/types";
import {
  createBooleanField,
  createTextField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum ComboFilterKeys {
  enable = "enable",
  name = "name",
  products = "products"
}

export interface ComboListFilterOpts {
  enable: FilterOpts<boolean>;
  name: FilterOpts<string>;
  products: FilterOpts<string>;
}

const messages = defineMessages({
  enable: {
    defaultMessage: "Enable",
    description: "combo"
  },
  name: {
    defaultMessage: "Name",
    description: "combo"
  },
  products: {
    defaultMessage: "Products",
    description: "combo"
  }
});
export function createFilterStructure(
  intl: IntlShape,
  opts: ComboListFilterOpts
): IFilter<ComboFilterKeys> {
  return [
    {
      ...createTextField(
        ComboFilterKeys.name,
        intl.formatMessage(messages.name),
        opts.name.value
      ),
      active: opts.name.active
    },
    {
      ...createTextField(
        ComboFilterKeys.products,
        intl.formatMessage(messages.products),
        opts.products.value
      ),
      active: opts.products.active
    },
    {
      ...createBooleanField(
        ComboFilterKeys.enable,
        intl.formatMessage(messages.enable),
        opts.enable.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.enable.active
    }
  ];
}
